<template>
    <ActionButton v-if="messages.count !== messages_selection.count"
        @click="onSelectAll"
        :badge="' (' + messages.count + ')'"
        icon='far fa-check-square'
        text="messages.actions.select_all"
        class="clear"
    />

    <ActionButton v-if="messages.count === messages_selection.count"
        @click="onSelectReset"
        :badge="' (' + messages.count + ')'"
        icon='far fa-square'
        text="messages.actions.select_reset"
        class="clear"
    />

    <hr />

    <ActionButton v-if="messages_selection.unread > 0"
        @click="onRead"
        icon='far fa-envelope'
        text="messages.actions.mark_read"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_flags',
          block  : props.block,
          action : 'mark_read'
        }"
    />
    <ActionButton v-if="messages_selection.read > 0"
        @click="onUnread"
        icon='fas fa-envelope'
        text="messages.actions.mark_unread"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_flags',
          block  : props.block,
          action : 'mark_unread'
        }"
    />

    <ActionButton
        @click="onMove"
        icon='fas fa-folder-open'
        text="messages.actions.move_message"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_move_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <ActionButton
        @click="onDelete"
        icon='fas fa-trash-alt'
        text="messages.actions.move_trash"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_delete',
          block  : props.block,
          action : 'delete'
        }"
    />

    <hr v-if="messages_selection.count <= limits.spam"/>

    <ActionButton v-if="messages.folder_id !== 'U3BhbQ' && messages_selection.count <= limits.spam"
        @click="onSpam"
        icon='fas fa-shield-alt'
        text="messages.actions.mark_spam"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_spam',
          block  : props.block,
          action : 'mark_spam'
        }"
    />

    <ActionButton v-if="messages.folder_id === 'U3BhbQ' && messages_selection.count <= limits.spam"
        @click="onNotSpam"
        icon='fas fa-ban'
        text="messages.actions.mark_not_spam"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_spam',
          block  : props.block,
          action : 'mark_not_spam'
        }"
    />

    <ActionButton v-if="messages_selection.count <= limits.blacklist"
        @click="onBlacklistEmail"
        icon='fas fa-lock'
        text="messages.actions.blacklist_email"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'blacklist_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <ActionButton v-if="messages_selection.count <= limits.whitelist"
        @click="onWhitelistEmail"
        icon='fas fa-lock-open'
        text="messages.actions.whitelist_email"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'whitelist_modal',
          block  : props.block,
          action : 'open'
        }"
    />

    <hr />

    <ActionButton
        @click="onAddFilter"
        icon='fas fa-filter'
        text="messages.actions.add_filter"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'filters_form',
          block  : props.block,
          action : 'open'
        }"
    />
    <ActionButton
        @click="onForward"
        icon='fas fa-share'
        text="messages.actions.forward"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'forward_form',
          block  : props.block,
          action : 'open'
        }"
    />

    <ActionButton v-if="messages_selection.unflagged > 0"
        @click="onFlag"
        icon='fas fa-bookmark'
        text="messages.actions.mark_flagged"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_flags',
          block  : props.block,
          action : 'mark_flagged'
        }"
    />
    <ActionButton v-if="messages_selection.flagged   > 0"
        @click="onUnflag"
        icon='far fa-bookmark'
        text="messages.actions.mark_unflagged"
        class="clear"
        :gtm="{
          module : 'messages',
          feature: 'message_flags',
          block  : props.block,
          action : 'mark_unflagged'
        }"
    />
</template>

<script setup>
    import {defineProps}          from 'vue';
    import ActionButton           from '@/vue/Elements/Buttons/ActionButton.vue';
    import SAPOMailConfig         from '@/SAPOMailConfig';

    const limits = SAPOMailConfig.client.endpoints.context.selection_limit;

    const props = defineProps({
        messages_selection : {},
        messages_view      : {},
        messages           : {},
        block              : {
            default: null,
        }
    })

  const onSelectAll = () => {
    props.messages_view.onActionSelectAll(props.messages.index);
  }

  const onSelectReset = () => {
    props.messages_view.onActionSelectReset();
  }

  const onRead = () => {
    props.messages_view.onActionRead(props.messages_selection);
  }

  const onUnread = () => {
    props.messages_view.onActionUnread(props.messages_selection);
  }

  const onMove = () => {
    props.messages_view.onActionMove(props.messages_selection);
  }

  const onDelete = () => {
    props.messages_view.onActionDelete(props.messages_selection);
  }

  const onSpam = () => {
    props.messages_view.onActionSpam(props.messages_selection);
  }

  const onNotSpam = () => {
    props.messages_view.onActionNotSpam(props.messages_selection);
  }

  const onBlacklistEmail = () => {
    props.messages_view.onActionBlacklist(props.messages_selection);
  }

  const onWhitelistEmail = () => {
    props.messages_view.onActionWhitelist(props.messages_selection);
  }

  const onAddFilter = () => {
    props.messages_view.onActionAddFilter(props.messages_selection);
  }

  const onForward = () => {
    props.messages_view.onActionForward(props.messages_selection);
  }

  const onFlag = () => {
    props.messages_view.onActionFlag(props.messages_selection);
  }

  const onUnflag = () => {
    props.messages_view.onActionUnflag(props.messages_selection);
  }
</script>
